import { Alert, Text } from '@indeed/ifl-components';

const SampleDataNotice = () => (
  <Alert status="info" sx={{ marginBlockStart: 4 }}>
    <Text>Sample data (preview only) — live values appear on indeed.com</Text>
  </Alert>
);

export default SampleDataNotice;
